/**
 * Checks if the browser supports the field-sizing CSS property
 */
export const isFieldSizingSupported = (): boolean => {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) return true;
	return CSS.supports('field-sizing', 'content');
};
